import * as yup from 'yup'

export const notaryContactValidationSchema = yup.object().shape({
    notaryName: yup.string().required('Le nom du notaire est requis'),
    scpName: yup.string().required('Le nom de la SCP est requis'),
    address: yup.string().required('L\'adresse est requise'),
    postalCode: yup
        .string()
        .required('Le code postal est requis')
        .matches(/^\d{5}$/, 'Le code postal doit contenir 5 chiffres'),
    city: yup.string().required('La ville est requise'),
})